import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import { ActionSource } from 'owa-mail-store';

/**
 * Add add a mailbox to the user's safe sender list
 * @param mailbox mailbox to be added to the safe sender list
 * @param itemId itemId of the item being added to the list
 * @param actionSource source of the action
 */
export const addMailboxToSafeSenders = action(
    'ADD_MAILBOX_TO_SAFE_SENDERS',
    (mailbox: EmailAddressWrapper, itemId: string, actionSource: ActionSource) =>
        addDatapointConfig(
            {
                name: 'TnS_AddToSafeSenders',
                customData: [actionSource],
                cosmosOnlyData: JSON.stringify({ itemId: itemId }),
                actionSource: 'ReadingPane',
            },
            {
                mailbox,
                itemId,
                actionSource,
            }
        )
);

/**
 * Add add a mailbox the the userConfig trusted sender list property
 * @param mailbox mailbox to be added to trusted safe sender list
 * @param junkEmailConfiguration the user's junkEmailConfiguration from their userOptions
 */
export const addMailboxToTrustedSendersList = action(
    'ADD_MAILBOX_TO_TRUSTED_SENDERS_LIST',
    (
        mailbox: EmailAddressWrapper,
        junkEmailConfiguration: MailboxJunkEmailConfigurationOptions
    ) => ({
        mailbox,
        junkEmailConfiguration,
    })
);
